import { render, staticRenderFns } from "./Partner_PAW_detail.vue?vue&type=template&id=69bfa81d&scoped=true&"
import script from "./Partner_PAW_detail.vue?vue&type=script&lang=js&"
export * from "./Partner_PAW_detail.vue?vue&type=script&lang=js&"
import style0 from "./Partner_PAW_detail.vue?vue&type=style&index=0&id=69bfa81d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69bfa81d",
  null
  
)

export default component.exports